import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    isActive: state.ngum.isNGUMActive,
  };
};
const mapDispatchToProps = null;

function NGUMStatus({ isActive = false, className = "" }) {
  const statusClass = isActive ? "w3-text-green" : "w3-text-red";
  return (
    <div className={`w3-border w3-round w3-white ${className}`}>
      <div className={`pad-big-lr pad-tb w3-large ${statusClass}`}>
        {isActive ? "eingeschaltet" : "ausgeschaltet"}
      </div>
    </div>
  );
}

NGUMStatus.propTypes = {
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(NGUMStatus);
